"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsEveryoneTeam = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var usePermissionObject_1 = require("./usePermissionObject");
var usePermissionDisplayMode_1 = require("./usePermissionDisplayMode");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var PrivacyStatusConfirmation_1 = require("./PrivacyStatusConfirmation");
var PermissionsEveryoneTeam = function () {
    var _a = (0, usePermissionObject_1.usePermissionObject)(), objectType = _a.objectType, objectId = _a.objectId;
    var _b = (0, usePermissionsModalContext_1.usePermissionsModalContext)(), _js = _b._js, workspaceName = _b.workspaceName, usePermissions = _b.usePermissions, useSetPrivacyStatus = _b.useSetPrivacyStatus;
    var mode = (0, usePermissionDisplayMode_1.usePermissionDisplayMode)();
    var permissions = usePermissions(objectType, objectId).data;
    var _c = (0, react_1.useDisclosure)(), isOpen = _c.isOpen, onOpen = _c.onOpen, onClose = _c.onClose;
    var privacyStatusMutation = useSetPrivacyStatus(objectType, objectId, {
        onSuccess: onClose,
        onError: onClose,
    });
    var title = workspaceName
        ? // Translators: %1 -> workspace name
            _js('Everyone in %1', workspaceName)
        : _js('Everyone');
    var hasAccessOptionValue = _js('Has Access');
    var removeAccessOptionValue = _js('Remove Access');
    if ((permissions === null || permissions === void 0 ? void 0 : permissions.privacyStatus) !== 'public') {
        return null;
    }
    return (React.createElement(react_1.Flex, { justify: "space-between", "data-testid": "permissions-everyone-team" },
        React.createElement(react_1.Stack, { align: "center", direction: "row", spacing: 4 },
            React.createElement(react_1.Avatar, { icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faBuilding }), color: "white" }),
            React.createElement(react_1.Flex, { fontWeight: "600" }, title)),
        mode === 'view' && (React.createElement(react_1.Flex, { opacity: 0.5, px: 4, align: "center" }, hasAccessOptionValue)),
        mode === 'edit' && (React.createElement(React.Fragment, null,
            React.createElement(react_1.Menu, { placement: "bottom-end" },
                React.createElement(react_1.MenuButton, { as: react_1.Button, variant: "ghost", borderColor: "gray.300", fontWeight: "400", minW: "auto", rightIcon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faChevronDown }), "data-testid": "permissions-everyone-team-edit-menu-button" }, hasAccessOptionValue),
                React.createElement(react_1.MenuList, { boxShadow: "md" },
                    React.createElement(react_1.MenuOptionGroup, { value: hasAccessOptionValue, type: "radio" },
                        React.createElement(react_1.MenuItemOption, { value: hasAccessOptionValue, fontSize: "md", fontWeight: "normal", "data-testid": "permissions-everyone-team-edit-option-public" }, hasAccessOptionValue),
                        React.createElement(react_1.MenuItemOption, { value: removeAccessOptionValue, fontSize: "md", fontWeight: "normal", "data-testid": "permissions-everyone-team-edit-option-private", onClick: onOpen }, removeAccessOptionValue)))),
            React.createElement(PrivacyStatusConfirmation_1.PrivacyStatusConfirmation, { isOpen: isOpen, onClose: onClose, privacyStatusMutation: privacyStatusMutation, newPrivacyStatus: "private", topIcon: pro_solid_svg_icons_1.faLock, headingText: _js('Set to Private?'), message: _js('Setting this to no access will immediately restrict access to the teams and users specified in this access list. Admins can still update access on private content.'), confirmButtonOptions: {
                    icon: pro_regular_svg_icons_1.faLock,
                    text: _js('Make Private'),
                    colorScheme: 'red',
                    color: 'red.600',
                } })))));
};
exports.PermissionsEveryoneTeam = PermissionsEveryoneTeam;
